module.exports = __webpack_public_path__ + "media/images/application/template/logo-b8963945c10801115fd66fa36cce117c.svg";